(function () {
    'use strict';

    run.pages.brandingEditor = function() {
        document.addEventListener('click',function(e) {
            const deleteButton = document.getElementById('branding_logo_delete');
            let clicked_save_button = e.target.closest('#branding_logo_delete');
            if (clicked_save_button) {
                Swal.fire({
                    title: deleteButton.dataset.title,
                    html: deleteButton.dataset.content,
                    showCloseButton: false,
                    showCancelButton: true,
                    showConfirmButton: true,
                    focusCancel: true,
                    cancelButtonText: deleteButton.dataset.cancelButton,
                    confirmButtonText: deleteButton.dataset.confirmButton,
                    buttonsStyling: false,
                    reverseButtons: true,
                    customClass: {
                        cancelButton: 'btn btn-light',
                        confirmButton: 'btn btn-danger ms-4'
                    },
                    showClass: {
                        popup: 'animate__animated animated__fast animate__fadeInUp'
                    },
                    hideClass: {
                        popup: 'animate__animated animated__fast animate__fadeOutDown'
                    }
                }).then((result) => {
                    if (result.value) {
                        window.location.href = deleteButton.dataset.href;
                    }
                });
            }
        });
    };
})();